import styles from "./OnboardingVolunteer.module.scss";
import classNames from "classnames";
import { useEnumStore } from "../../store/enumStore";
import { EventInterestsSkillsSection } from "../EventInterestsSkillsSection/EventInterestsSkillsSection";

import { MunicipalitySuggestion } from "../InputMunicipality/InputMunicipality";

interface OnboardingVolunteerThirdStepProps {
  title: string;
  desc: string;
  formData: {
    skills: string[];
    interests: string[];
    locations: MunicipalitySuggestion[];
  };
  onCheckboxToggle: (id: string, field: "skills" | "interests") => void;
}

export const OnboardingVolunteerThirdStep = ({
  title,
  desc,
  formData,
  onCheckboxToggle,
}: OnboardingVolunteerThirdStepProps) => {
  const interests = useEnumStore((state) => state.interests);

  return (
    <div className={classNames(styles.content)}>
      <h2>{title}</h2>
      <p>{desc}</p>
      <EventInterestsSkillsSection
        title=""
        items={interests as any}
        selectedIds={formData.interests}
        onToggle={(id) => onCheckboxToggle(id, "interests")}
        editMode={true}
        userType="volunteer"
        showSubItems={true}
        type="interests"
      />
    </div>
  );
};
